<dx-form [formData]="tpvSettings" class="form last plain-styled-form" labelMode="floating" [readOnly]="formIsReadOnly">
  <dxi-item itemType="tabbed">
    <dxo-tab-panel-options [showNavButtons]="true" stylingMode="secondary" tabsPosition="left"></dxo-tab-panel-options>

    <dxi-tab title="Saisie" [colCount]="2">
      <dxi-item dataField="clientParDefautId" [label]="{text: 'Client par défaut'}" [colSpan]="colSpan"
        editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: partenaireDataSource,
          displayExpr: partenaireEtTypesDisplayExpr,
          searchEnabled: true,
          valueExpr: 'id',
          showClearButton: true,
          searchExpr: ['intitule', 'codeBo'],
          showDataBeforeSearch: true
        }"
      ></dxi-item>

      <dxi-item dataField="cumulScanSurUnArticle" [label]="{text: 'Cumul des scans sur un article'}"
        editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: cumulScanSurUnArticleDataSource,
          valueExpr: 'id',
          displayExpr: 'intitule',
          showClearButton: true
        }"
      ></dxi-item>

      <dxi-item dataField="typeRemiseParDefautId" [label]="{text: 'Type de remise par défaut'}"
        editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: typeRemises,
          valueExpr: 'id',
          displayExpr: 'intitule',
          showClearButton: true
        }"
      ></dxi-item>

      <dxi-item dataField="dureeAvertissementExpirationCarte" [label]="{text: 'Durée avertissement expiration carte (en jours)'}" [colSpan]="colSpan"
        editorType="dxNumberBox" [editorOptions]="{ format: { type: 'fixedPoint', precision: 0 } }"
      ></dxi-item>

      <dxi-item dataField="isCalculPrixUnitaireMultiTaxes" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox" [editorOptions]="{ text: 'Conversion HT/TTC multi taxe', enableThreeStateBehavior: true }"
      ></dxi-item>

      <dxi-item dataField="saisieVendeur" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox" [editorOptions]="{ text: 'Saisie vendeur', enableThreeStateBehavior: true }"
      ></dxi-item>

      <dxi-item dataField="saisieObligVendeur" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox" [editorOptions]="{ text: 'Saisie vendeur obligatoire', enableThreeStateBehavior: true }"
      ></dxi-item>

      <dxi-item dataField="permettreVarianteSaisieTextuelle" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox" [editorOptions]="{ text: 'Permettre la saisie textuelle des variantes', enableThreeStateBehavior: true }"
      ></dxi-item>

      <dxi-item dataField="terminerSurTicketOuFacture" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox" [editorOptions]="{ text: 'Terminer sur ticket ou facture', enableThreeStateBehavior: true }"
      ></dxi-item>

      <dxi-item dataField="messageAccueil" colSpan="2" [label]="{text: 'Message d\'accueil'}" editorType="dxTextArea" [editorOptions]="{height: 80}"></dxi-item>

      <!-- #region Conditions de sélection obligatoire de client -->
      <dxi-item itemType="group" [caption]="'Conditions de sélection obligatoire de client'" [visible]="siteId == null">

        <dxi-item dataField="selectionObligatoireClientSettings.informationSuiviSAV" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox" [editorOptions]="{ text: 'Information suivi SAV', enableThreeStateBehavior: true }"
        />

        <dxi-item dataField="selectionObligatoireClientSettings.informationGarantie" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox" [editorOptions]="{ text: 'Information garantie', enableThreeStateBehavior: true }"
        />

        <!-- Types de mouvement -->
        <dxi-item >
          <div *dxTemplate>
            <dx-tag-box
            label="Types de mouvement"
            [items]="typesMouvementDataSource"
            valueExpr="codeBo"
            [(value)]="this.tpvSettings.selectionObligatoireClientSettings.mouvementTypeCodeBoList"
            [searchEnabled]="true"
            [showSelectionControls]="true"
            [searchExpr]="['codeBo']"
            [readOnly]="formIsReadOnly"
            [displayExpr]="partenaireEtTypesDisplayExpr"
            placeholder="Sélectionnez un type de mouvement"
            />
          </div>
        </dxi-item>

        <!-- Classifications -->
        <dxi-item >
          <div *dxTemplate>
            <dx-tag-box
            label="Classification articles"
            [items]="classificationsValuesDataSource"
            valueExpr="codeBo"
            [(value)]="this.tpvSettings.selectionObligatoireClientSettings.classificationCodeBoList"
            [searchEnabled]="true"
            [showSelectionControls]="true"
            [searchExpr]="['codeBo', 'intitule']"
            [readOnly]="formIsReadOnly"
            [displayExpr]="partenaireEtTypesDisplayExpr"
            placeholder="Sélectionnez un type de classification"
            />
          </div>
        </dxi-item>
      </dxi-item>
      <!-- #endregion -->

      <!-- #region Avertissement taxe à la sélection du client -->
      <dxi-item itemType="group" [caption]="'Avertissement taxe à la sélection du client'" [visible]="siteId == null" [colSpan]="2">
        <dxi-item dataField="avertissementTaxeActive" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{ text: 'Activer l\'avertissement à la sélection du client', enableThreeStateBehavior: true, onValueChanged: onAvertissementTaxeActiveChanged }"
        ></dxi-item>

        <dxi-item dataField="avertissementTaxeDestinationId" [label]="{text: 'Taxe de destination à détecter'}" [colSpan]="colSpan"
          editorType="dxSelectBox"
          [editorOptions]="{
            dataSource: taxesDataSource,
            valueExpr: 'id',
            displayExpr: taxeDisplayExpr,
            searchEnabled: true,
            searchExpr: ['intitule', 'codeBo'],
            showClearButton: true
          }"
          hint="Si une exception de taxe du client substitue vers cette taxe, le caissier est averti à la sélection du client."
        ></dxi-item>

        <dxi-item dataField="avertissementTaxeMessage" [colSpan]="2" [label]="{text: 'Message affiché au caissier'}"
          editorType="dxTextArea" [editorOptions]="{ height: 80 }"
        ></dxi-item>

        <dxi-item [colSpan]="2">
          <div *dxTemplate>
            <div class="info-note">
              <strong>Variables disponibles :</strong>
              <span class="variable-name">{{ '{' }}client{{ '}' }}</span> nom du client,
              <span class="variable-name">{{ '{' }}taxe{{ '}' }}</span> intitulé de la taxe,
              <span class="variable-name">{{ '{' }}taux{{ '}' }}</span> taux de la taxe.
            </div>
          </div>
        </dxi-item>
      </dxi-item>
      <!-- #endregion -->

      <dxi-item itemType="group" [caption]="'Recherche partenaires'" [visible]="(siteId == null)">
        <dxi-item >
          <div *dxTemplate>
            <dx-tag-box
              label="Profils partenaires"
              [items]="profilsPartenairesDataSource"
              valueExpr="id"
              [(value)]="this.tpvSettings.rechercheClientProfilsAutorisesId"
              [searchEnabled]="true"
              [showSelectionControls]="true"
              [searchExpr]="['intitule']"
              [readOnly]="formIsReadOnly"
              displayExpr="intitule"
              placeholder="Sélectionnez les profils partenaires à rechercher"
              />
            </div>
          </dxi-item>

          <dxi-item dataField="exclureRechercheClientAnonyme" editorType="dxCheckBox" [label]="{visible: false}" [colSpan]="colSpan"
          [editorOptions]="{
            text: 'Exclure les clients anonymes',
            enableThreeStateBehavior: false
          }"
          />

        </dxi-item>
        <dxi-item itemType="group" [colCount]="2" caption="Historique des ventes en caisse" cssClass="historique-ventes-group">
          <dxi-item [colSpan]="1" cssClass="tri-config-item">
            <div *dxTemplate>
              <app-configuration-tri
                title="Tri de l'historique des ventes"
                [properties]="historiqueVenteTri"
                [(triConfiguration)]="tpvSettings.triHistoriqueTransactions"
                [disabled]="formIsReadOnly">
              </app-configuration-tri>
            </div>
          </dxi-item>
          <dxi-item [colSpan]="1" cssClass="site-selection-item" dataField="defaultSiteIdHistoriqueTransaction" editorType="dxSelectBox"
              [label]="{ text: 'Site par défaut pour l\'historique des ventes' }" [editorOptions]="{
              dataSource: siteDataSource,
              valueExpr: 'id',
              displayExpr: 'intitule',
              showClearButton: true,
              width : '300px'
            }">
          </dxi-item>
        </dxi-item>
      </dxi-tab>

      <dxi-tab title="Gestion des fonds">
        <dxi-item dataField="optionPrelevementClotureCaisse" editorType="dxSelectBox"
          [label]="{ text: 'Prélèvement automatique à la clôture' }" [colSpan]="colSpan" [editorOptions]="{
            text: ' ',
            dataSource: optionPrelevementClotureCaisseDataSource,
            valueExpr: 'id',
            displayExpr: 'intitule',
            showClearButton: true
          }"
        ></dxi-item>

        <dxi-item dataField="fondReference" editorType="dxNumberBox" [label]="{ text: 'Fond de référence ' }"
          [editorOptions]="{text: ' '}" hint="Montant à atteindre par le prélèvement automatique effectué à la clôture"
          [colSpan]="colSpan"
        ></dxi-item>

        <dxi-item dataField="destinationPrelevementParDefautId" editorType="dxSelectBox"
          [label]="{ text: 'Destinaton des prélèvements par default' }" [editorOptions]="{
            text: '',
            dataSource: lieuStockageDataSource,
            valueExpr: 'id',
            displayExpr: 'intitule',
            showClearButton: true
          }" [colSpan]="colSpan"
        ></dxi-item>

        <dxi-item dataField="controleObligatoireOuverture" editorType="dxCheckBox" [label]="{visible: false}"
          [editorOptions]="{
            text: 'Contrôle obligatoire à l\'ouverture',
            enableThreeStateBehavior: true
          }"
          [colSpan]="colSpan"
        ></dxi-item>

        <dxi-item dataField="controleObligatoireFermeture" editorType="dxCheckBox" [label]="{visible: false}"
          [editorOptions]="{
            text: 'Contrôle obligatoire à la fermeture',
            enableThreeStateBehavior: true
          }"
          [colSpan]="colSpan"
        ></dxi-item>
        <dxi-item dataField="isLieuStockageApportPrelevementObligatoire" editorType="dxCheckBox"
          [label]="{visible: false}"
          [editorOptions]="{
            text: 'Stockage source/destination obligatoire pour les prélèvements/apports.',
            enableThreeStateBehavior: true
          }"
          [colSpan]="colSpan"
        ></dxi-item>
      </dxi-tab>

      <dxi-tab title="Stock">
        <dxi-item dataField="utilisationEntrepotPreferentiel" editorType="dxCheckBox" [label]="{visible: false}"
          [editorOptions]="{
            text: 'Utilisation entrepot préférentiel',
            enableThreeStateBehavior: true
          }" [colSpan]="colSpan"
        ></dxi-item>

        <dxi-item dataField="multiEntrepotEnabled" editorType="dxCheckBox" [label]="{visible: false}"
          [editorOptions]="{
            text: 'Activation multi-entrepôts',
            enableThreeStateBehavior: true
          }" [colSpan]="colSpan"
        ></dxi-item>
        <dxi-item dataField="isInventaireObligatoireAvantCloture" editorType="dxCheckBox" [label]="{visible: false}"
          [editorOptions]="{
            text: 'Forcer l\'inventaire à la clôture.',
            enableThreeStateBehavior: true
          }" [colSpan]="colSpan"
        ></dxi-item>
        <dxi-item dataField="forcerVerificationStockAvantAjoutArticle" editorType="dxCheckBox"
          [label]="{visible: false}"
          [editorOptions]="{
            text: 'Forcer vérification du stock à l\'ajout d\'article',
            enableThreeStateBehavior: true
          }" [colSpan]="colSpan"
        ></dxi-item>

        <dxi-item dataField="bloquerVenteSiCaisseHorsConnexionEtVerificationStockForcee" editorType="dxCheckBox"
          [label]="{visible: false}"
          [editorOptions]="{
            text: 'Bloquer vente si caisse hors connexion et vérification du stock forcée',
            enableThreeStateBehavior: true
          }" [colSpan]="colSpan"
        ></dxi-item>

        <dxi-item dataField="activationFonctionnaliteResteALivrer" editorType="dxCheckBox"
          [label]="{visible: false}"
          [editorOptions]="{
            text: 'Activer la fonctionnalité reste à livrer',
            enableThreeStateBehavior: true
          }" [colSpan]="colSpan"
        ></dxi-item>
      </dxi-tab>

      <dxi-tab title="Sécurité" [colCount]="2">
        <dxi-item itemType="group">
          <dxi-item dataField="authentificationType" [label]="{text: 'Type d\'authentification'}" [colSpan]="colSpan"
            editorType="dxSelectBox"
            [editorOptions]="{
              dataSource: caisseTypeAuthentification,
              searchEnabled: true,
              displayExpr: 'intitule',
              valueExpr: 'id',
              showClearButton: true,
              searchExpr: ['intitule', 'codeBo'],
              showDataBeforeSearch: true
            }"
          ></dxi-item>

          <dxi-item dataField="authentificationDomain" [label]="{text: 'Domaine d\'authentification'}"
            [colSpan]="colSpan"
          ></dxi-item>

          <dxi-item dataField="elevationPrivilegeAuthentificationType"
            [label]="{text: 'Type d\'authentification pour l\'élévation de privilège'}" [colSpan]="colSpan"
            editorType="dxSelectBox"
            [editorOptions]="{
              dataSource: elevationPrivilegeAuthentificationType,
              searchEnabled: true,
              displayExpr: 'intitule',
              valueExpr: 'id',
              showClearButton: true,
              searchExpr: ['intitule', 'codeBo'],
              showDataBeforeSearch: true
            }"
          ></dxi-item>
        </dxi-item>

        <dxi-item itemType="group">
        <dxi-item dataField="identificationAvantVente" [label]="{visible: false}"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Identification avant vente',
            enableThreeStateBehavior: true
          }" [colSpan]="colSpan"
        ></dxi-item>

        <dxi-item dataField="verrouillageApresVente" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Verrouillage après une vente',
            enableThreeStateBehavior: true
          }"
        ></dxi-item>

        <dxi-item dataField="multiCaissier" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Activation multi-caissier',
            enableThreeStateBehavior: true
          }"
        ></dxi-item>

        <dxi-item dataField="pieceRechercheAvancee" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Panneau de recherche avancée de pièce',
            enableThreeStateBehavior: true
          }"
        ></dxi-item>

        <dxi-item dataField="isBPProcurationReexpeditionVisible" [visible]="isNiuora" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Afficher les fonctionnalités des boîtes postales, procurations et réexpéditions',
            enableThreeStateBehavior: true
          }"
        ></dxi-item>

        <dxi-item  dataField="activerCarteClient" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Activer la carte client',
            enableThreeStateBehavior: true,
            elementAttr: { id: 'activerCarteClient' }
          }"
        ></dxi-item>

        <dxi-item dataField="exclureRechercheClientAnonyme" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox" [editorOptions]="{ text: 'Exclure les clients anonymes', enableThreeStateBehavior: false}"
        />
      </dxi-item>
    </dxi-tab>

    <dxi-tab title="Matériel" [colCount]="4">
      <dxi-item dataField="lienTpe" [colSpan]="1" [label]="{visible: false}"
        editorType="dxCheckBox"
        [editorOptions]="{ text: 'Lien TPE', enableThreeStateBehavior: true }"
      ></dxi-item>

      <dxi-item dataField="versionCibleMiseAJour" editorType="dxSelectBox" [editorOptions]="versionsTpvOptions"  [colSpan]="1" [label]="{text: 'Version pour mise à jour'}"></dxi-item>
      <dxi-item dataField="cleLicenceWacomSignature" [colSpan]="2" [label]="{text: 'Clé d\'utilisation WACOM'}"></dxi-item>
    </dxi-tab>

    <dxi-tab title="Fret armateur">
      <dxi-item dataField="activerModeFret" [label]="{text:'Activer mode fret'}" editorType="dxSwitch"></dxi-item>
    </dxi-tab>

    <dxi-tab title="Préférences" [colCount]="1">

      <dxi-item itemType="group" [caption]="'Personnalisation de l\'affichage des lignes du panier'" [colSpan]="1" [colCount]="1">
        <dxi-item>
          <div *dxTemplate>
            <div class="variables-info">
              <div class="variable-section">
                <h4 class="variable-section-title">Variables disponibles</h4>
                <div class="variable-item" *ngFor="let colonne of colonnesPatternLignePanier">
                  <span class="variable-name">{{ colonne.value }}</span>
                  <span class="variable-desc">{{ colonne.intitule }}</span>
                </div>
              </div>

              <div class="variable-section">
                <h4 class="variable-section-title">Options de formatage</h4>
                <div class="variable-item">
                  <span class="variable-name">{{ '{' }}IntituleLigne:10{{ '}' }}</span>
                  <span class="variable-desc">Limite la taille à 10 caractères maximum</span>
                </div>
                <div class="variable-item">
                    <span class="variable-name">{{ '{' }}IntituleLigne,10{{ '}' }}</span>
                  <span class="variable-desc">Ajoute un espacement de 10 caractères à gauche du texte</span>
                </div>
                <div class="variable-item">
                    <span class="variable-name">{{ '{' }}IntituleLigne,-10{{ '}' }}</span>
                  <span class="variable-desc">Ajoute un espacement de 10 caractères à droite du texte</span>
                </div>
                <div class="variable-item">
                    <span class="variable-name">{{ '{' }}IntituleLigne,-10:5{{ '}' }}</span>
                  <span class="variable-desc">Limite le nombre de caractères à 5 et ajoute un espacement de 10 caractères à droite du texte</span>
                </div>
                <div class="info-note">
                  <strong>Note :</strong> Utilisez ":N" pour limiter la taille, ",N" pour l'espacement à gauche, ",-N" pour l'espacement à droite. Les options peuvent être combinées.
                </div>
              </div>
            </div>
          </div>
        </dxi-item>

        <!-- Configuration des Patterns -->
        <dxi-item itemType="group" caption="Configuration des Patterns" [colSpan]="1" [colCount]="1">

          <!-- Pattern Ligne 1 -->
          <dxi-item [colSpan]="1">
            <div *dxTemplate>
              <div class="pattern-row">
                <div class="pattern-input">
                  <label class="pattern-label">Pattern ligne 1 (Intitulé ligne par défaut)</label>
                  <dx-text-box
                    [(value)]="tpvSettings.patternPanierLigne1"
                    [readOnly]="formIsReadOnly"
                    placeholder="Ex: &#123;CodeArticle&#125; - &#123;CodeEntrepot&#125;"
                    [height]="40"
                    [showClearButton]="true"
                  ></dx-text-box>
                  <div class="pattern-hint">Remplace uniquement l'intitulé de la ligne (quantités, remises et prix restent inchangés)</div>
                </div>
                <div class="pattern-example" *ngIf="apercuLigne1">
                  <div class="pattern-preview">
                    <strong>Aperçu :</strong> <em>{{ apercuLigne1 }}</em>
                  </div>
                </div>
              </div>
            </div>
          </dxi-item>

          <!-- Pattern Ligne 2 -->
          <dxi-item [colSpan]="1">
            <div *dxTemplate>
              <div class="pattern-row">
                <div class="pattern-input">
                  <label class="pattern-label">Pattern ligne 2 (complémentaire)</label>
                  <dx-text-box
                    [(value)]="tpvSettings.patternPanierLigne2"
                    [readOnly]="formIsReadOnly"
                    placeholder="Ex: Entrepôt: &#123;IntituleEntrepot&#125;"
                    [height]="40"
                    [showClearButton]="true"
                  ></dx-text-box>
                  <div class="pattern-hint">Ligne complémentaire affichée sous la ligne principale</div>
                </div>
                <div class="pattern-example" *ngIf="apercuLigne2">
                  <div class="pattern-preview">
                    <strong>Aperçu :</strong> <em>{{ apercuLigne2 }}</em>
                  </div>
                </div>
              </div>
            </div>
          </dxi-item>

          <!-- Pattern Ligne 3 -->
          <dxi-item [colSpan]="1">
            <div *dxTemplate>
              <div class="pattern-row">
                <div class="pattern-input">
                  <label class="pattern-label">Pattern ligne 3 (complémentaire)</label>
                  <dx-text-box
                    [(value)]="tpvSettings.patternPanierLigne3"
                    [readOnly]="formIsReadOnly"
                    placeholder="Ex: Entrepôt: &#123;IntituleEntrepot&#125;"
                    [height]="40"
                    [showClearButton]="true"
                  ></dx-text-box>
                  <div class="pattern-hint">Deuxième ligne complémentaire affichée sous la ligne 2</div>
                </div>
                <div class="pattern-example" *ngIf="apercuLigne3">
                  <div class="pattern-preview">
                    <strong>Aperçu :</strong> <em>{{ apercuLigne3 }}</em>
                  </div>
                </div>
              </div>
            </div>
          </dxi-item>
        </dxi-item>
      </dxi-item>
    </dxi-tab>

    <dxi-tab title="Scan" [colCount]="2">
      <dxi-item itemType="group" [caption]="'Vérifications de scan'">
        <dxi-item dataField="verificationCodeInterne" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Vérifier le code interne',
            enableThreeStateBehavior: true
          }"
        ></dxi-item>

        <dxi-item dataField="verificationReferenceFournisseur" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Vérifier la référence fournisseur',
            enableThreeStateBehavior: true
          }"
        ></dxi-item>
      </dxi-item>

      <dxi-item itemType="group" [caption]="'Type de recherche'">
        <dxi-item dataField="searchTypeScan" [label]="{text: 'Type de recherche'}" [colSpan]="colSpan"
          editorType="dxSelectBox"
          [editorOptions]="{
            dataSource: searchTypeDataSource,
            searchEnabled: true,
            displayExpr: 'intitule',
            valueExpr: 'id',
            showClearButton: true
          }"
          hint="Type de recherche appliqué à tous les champs activés (code-barre, code interne, référence fournisseur)"
        ></dxi-item>
      </dxi-item>

      <dxi-item itemType="group" [caption]="'Codes-barres poids/prix'">
        <dxi-item dataField="poidPrixEnabled" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Activer les codes poids/prix',
            enableThreeStateBehavior: true
          }"
        ></dxi-item>
      </dxi-item>
    </dxi-tab>
  </dxi-item>
</dx-form>

<dx-popover target="#activerCarteClient" trigger="hover" [showEvent]="{ name: 'mouseenter' }" [hideEvent]="{ name: 'mouseleave' }">
  <div>Force la vérification de la date de validité de la carte client à la sélection du client.</div>
</dx-popover>